/**
 * v0.4 追加要件⑰: アップロード可能な形式のフロント側表現。
 *
 * ⚠️ **権威は API 側の `apps/api/src/lib/documents/mime.ts`** (拡張子 + 申告MIME + マジックバイトの
 *  3段検証)。ここにあるのは UX のためのフィルタと説明文にすぎない。
 *  ⚠️ package 境界を越えて import できないため重複は避けられないが、
 *  **重複させてよいのはここだけ**にすること (2画面へ逐語コピーしない、§8-55)。
 */
export const DOCUMENT_ACCEPT = '.pdf,.png,.jpg,.jpeg,.gif,.webp,.docx,.xlsx,.pptx,.doc,.xls,.ppt,.txt,.csv';

/** ⚠️ D-478: Office/テキストはブラウザ内で表示できず「開く=ダウンロード」になる。必ず明示する。 */
export const DOCUMENT_FORMAT_HINT =
  'PDF・画像・Office ファイル (20MB まで)。'
  + 'Word / Excel / PowerPoint / テキストはブラウザ内で表示できないため、開くと端末に保存されます。';
